import React from 'react';
import { MentionsCardsContainer } from '../components/MentionsCardContainer';

export const PublicMentionsContainer = ({
  underMaintenance,
  names,
  mentionedUserId,
  mentionedUserUrl,
}) => {
  if (underMaintenance) {
    return (
      <div style={{ width: '100%', height: 600, position: 'relative' }}>
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: '18px',
            textAlign: 'center',
          }}
        >
          Apologies, the Mentions feature is undergoing a brief maintenance.
          Please try again in about an hour.
        </div>
      </div>
    );
  }
  return (
    <div className="DesignSystem">
      <div className="u-mt8x">
        <MentionsCardsContainer
          publicMentions
          currentFilter="is_me"
          names={names}
          mentionedUserId={mentionedUserId}
          mentionedUserUrl={mentionedUserUrl}
        />
      </div>
    </div>
  );
};

export default PublicMentionsContainer;
